import React from 'react';

const ColumnChartIcon = ({ size }: { size: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height="62"
      fill="none"
      viewBox="0 0 80 56"
    >
      <path fill="#3B82F6" d="M20 36H10v14h10z" opacity="0.9"></path>
      <path fill="#818CF8" d="M20 26H10v10h10z" opacity="0.9"></path>
      <path
        fill="#38BDF8"
        d="M18 18h-6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2"
        opacity="0.9"
      ></path>
      <path fill="#3B82F6" d="M34 40H24v10h10z" opacity="0.9"></path>
      <path fill="#818CF8" d="M34 26H24v14h10z" opacity="0.9"></path>
      <path
        fill="#38BDF8"
        d="M32 20h-6a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2"
        opacity="0.9"
      ></path>
      <path fill="#3B82F6" d="M48 34H38v16h10z" opacity="0.9"></path>
      <path fill="#818CF8" d="M48 26H38v8h10z" opacity="0.9"></path>
      <path
        fill="#38BDF8"
        d="M46 16h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2"
        opacity="0.9"
      ></path>
      <path fill="#3B82F6" d="M62 42H52v8h10z" opacity="0.9"></path>
      <path fill="#818CF8" d="M62 30H52v12h10z" opacity="0.9"></path>
      <path
        fill="#38BDF8"
        d="M60 22h-6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2"
        opacity="0.9"
      ></path>
      <path fill="#3B82F6" d="M76 38H66v12h10z" opacity="0.9"></path>
      <path fill="#818CF8" d="M76 28H66v10h10z" opacity="0.9"></path>
      <path
        fill="#38BDF8"
        d="M74 16h-6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2"
        opacity="0.9"
      ></path>
    </svg>
  );
};

export default ColumnChartIcon;
